import {
  GET_PATIENT_STATS,
  GET_EMAIL_MILESTONE,
  GET_FORM_MILESTONE,
  GET_LOGIN_MILESTONE,
  LOADER,
  GET_APPOINTMENT_PROCESS_TRACKER
} from './constants';
import { chrApi, phrApi } from '../../api/api';

function Loader() {
  return { type: LOADER };
}

export function getPatientStats(practiceId, providerId, startDate, endDate) {
  const stats = phrApi(
    'get',
    `patient_stats/practice/${practiceId}/provider/${providerId}/date/${startDate}/${endDate}`,
    null,
    null
  );
  return dispatch => {
    dispatch(Loader());
    stats
      .then(response =>
        dispatch({ type: GET_PATIENT_STATS, payload: response })
      )
      .catch(error => {
        console.log(error.response);
      });
  };
}

export function getEmailMilestone(patientId, appointmentId) {
  const emailMileStone = phrApi(
    'get',
    `email_milestone/patient/${patientId}/appointment/${appointmentId}`,
    null,
    null
  );

  return dispatch => {
    emailMileStone
      .then(response =>
        dispatch({ type: GET_EMAIL_MILESTONE, payload: response })
      )
      .catch(error => {
        console.log(error.response);
      });
  };
}

export function getLoginMilestone(patientId, appointmentId) {
  const emailMileStone = phrApi(
    'get',
    `login_milestone/patient/${patientId}/appointment/${appointmentId}`,
    null,
    null
  );

  return dispatch => {
    emailMileStone
      .then(response =>
        dispatch({ type: GET_LOGIN_MILESTONE, payload: response })
      )
      .catch(error => {
        console.log(error.response);
      });
  };
}

export function getFormMilestone(patientId, appointmentId) {
  const emailMileStone = phrApi(
    'get',
    `form_milestones/patient/${patientId}/appointment/${appointmentId}`,
    null,
    null
  );

  return dispatch => {
    emailMileStone
      .then(response =>
        dispatch({ type: GET_FORM_MILESTONE, payload: response })
      )
      .catch(error => {
        console.log(error.response);
      });
  };
}

export function getProcessTracker(appointmentId) {
  const trackerData = chrApi(
    'get',
    `process_tracker/appointment/${appointmentId}`,
    null,
    null
  );

  return dispatch => {
    trackerData
      .then(response =>
        dispatch({ type: GET_APPOINTMENT_PROCESS_TRACKER, payload: response })
      )
      .catch(error => {
        console.log(error.response);
      });
  };
}
